import Auth from "@aws-amplify/auth";
import { Alert, Button, Card, Col, Image, Row, Tag, Typography } from "antd";
import Title from "antd/es/typography/Title";
import dayjs from "dayjs";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getShopDetails, getSmsPackageDetails } from "../../service/service";
import { useAccess } from "../../provider/AccessProvider";
import { SETTINGSACCESS } from "../../utils/constant";
const { Text } = Typography;
function ShopProfile(props) {
  const dispatch = useDispatch();
  const shopDetails = useSelector((state) => state.shopDetails);
  const [packageList, setPackageList] = useState([]);
  const access = useAccess(SETTINGSACCESS);

  useEffect(() => {
    const packageList = [
      {
        packageName: "Billing Package",
        expiryDate: shopDetails.billingExpiryDate,
        status: moment().isSameOrBefore(
          moment(shopDetails.billingExpiryDate, "YYYY-MM-DD"),
          "date"
        ),
      },
      {
        packageName: "Loyalty Package",
        expiryDate: shopDetails.loyaltyExpiryDate,
        status: moment().isSameOrBefore(
          moment(shopDetails.loyaltyExpiryDate, "YYYY-MM-DD"),
          "date"
        ),
      },
      {
        packageName: "Appointment Package",
        expiryDate: shopDetails.appointmentExpiryDate,
        status: moment().isSameOrBefore(
          moment(shopDetails.appointmentExpiryDate, "YYYY-MM-DD"),
          "date"
        ),
      },
    ];

    (async function () {
      const smsPackageDetails = await getSmsPackageDetails(shopDetails.shopId);
      if (smsPackageDetails) {
        if (smsPackageDetails.smsPackage === "yes") {
          packageList.push({
            packageName: `Sms Package(${smsPackageDetails.smsCount}/${
              Math.ceil(smsPackageDetails.smsCount / 1000) * 1000
            })`,
            expiryDate: smsPackageDetails.smsExpiryDate,
            status: moment().isSameOrBefore(
              moment(smsPackageDetails.smsExpiryDate, "YYYY-MM-DD"),
              "date"
            ),
          });
        }
        dispatch({
          type: "SMS_PACKAGE",
          payload: {
            smsCount: smsPackageDetails.smsCount,
            smsExpiryDate: smsPackageDetails.smsExpiryDate,
            smsPackage: smsPackageDetails.smsPackage,
          },
        });
      }
    })();
    setPackageList(packageList);
  }, []);

  if (!access.viewProfile(false)) {
    return (
      <Alert
        style={{
          padding: "20px",
          textAlign: "center",
        }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }

  return (
    <div>
      <div className="settings-wrapper">
        <div
          style={{
            marginTop: 80,
            marginLeft: 0,
          }}
          className="settings-body"
        >
          <div
            style={{
              marginRight: "12px",
            }}
            className="setting-body-left"
          >
            <Image
              style={{
                width: "170px",
                height: "170px",
                objectFit: "fill",
                borderRadius: "50%",
                boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",
              }}
              preview={false}
              alt="shop profile"
              src={
                shopDetails.shopImageLocation !== "removed"
                  ? shopDetails.shopImageLocation
                  : "https://via.placeholder.com/300/ef4667/FFFFFF?text=GHOSHAK"
              }
            />

            <Card
              style={{
                width: 200,
                height: 100,
                marginTop: 20,
              }}
              bodyStyle={{
                textAlign: "center",
              }}
            >
              <Title level={5}>Mobile Number:</Title>
              <Text
                type="secondary"
                style={{
                  fontSize: "16px",
                }}
              >
                {shopDetails.phoneNumber}
              </Text>
            </Card>
            <Card
              style={{
                width: 200,
                height: 100,
                margin: "20px 0",
              }}
              bodyStyle={{
                textAlign: "center",
              }}
            >
              <Title level={5}>Shop ID:</Title>
              <Text
                type="secondary"
                style={{
                  fontSize: "16px",
                }}
              >
                {shopDetails.userId10Digit}
              </Text>
            </Card>
          </div>
          <div className="setting-body-right"></div>
          <Row gutter={20}>
            <Col span={12}>
              {shopDetails.empId && (
                <div style={{ marginTop: "0px" }}>
                  <label className="text-muted">Employee Name</label>
                  <div className="shopdetails-card">
                    <p>{shopDetails.employeeName}</p>
                  </div>
                </div>
              )}
              <div style={{ marginTop: "0px" }}>
                <Title level={5}>Shop Name</Title>
                <Card
                  bodyStyle={{
                    padding: 12,
                    width: "500px",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                    }}
                    type="secondary"
                  >
                    {" "}
                    {shopDetails.shopName}
                  </Text>
                </Card>
              </div>
              <div style={{ marginTop: "20px" }}>
                <Title level={5}>Shop Address</Title>
                <Card
                  bodyStyle={{
                    padding: 12,
                    width: "500px",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                    }}
                    type="secondary"
                  >
                    {shopDetails.shopAddress}
                  </Text>
                </Card>
              </div>
              <div style={{ marginTop: "20px" }}>
                <Title level={5}>Pincode</Title>
                <Card
                  bodyStyle={{
                    padding: 12,
                    width: "500px",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                    }}
                    type="secondary"
                  >
                    {shopDetails.userPincode}
                  </Text>
                </Card>
              </div>
              <div style={{ marginTop: "20px" }}>
                <Title level={5}>Shop Type</Title>
                <Card
                  bodyStyle={{
                    padding: 12,
                    width: "500px",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 18,
                    }}
                    type="secondary"
                  >
                    {shopDetails.shopType}
                  </Text>
                </Card>
              </div>
            </Col>
            <Col span={12}>
              {packageList.map((item, index) => {
                return (
                  <Fragment key={index}>
                    {/* <Col span={12}>
                        <Typography.Text
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.packageName}
                        </Typography.Text>
                      </Col>
                      <Col span={7}>
                        <Typography.Text>{item.expiryDate}</Typography.Text>
                      </Col>
                      <Col span={5}>
                        <Typography.Text>
                          {item.status ? (
                            <Tag color="green">Active</Tag>
                          ) : (
                            <Tag color="red">Expired</Tag>
                          )}
                        </Typography.Text>
                      </Col> */}
                    <Title level={5}>{item.packageName}</Title>
                    <Card
                      bodyStyle={{
                        padding: 12,
                        width: "500px",
                        alignItems: "center",
                        display: "flex",
                        gap: 8,
                      }}
                      style={{
                        marginBottom: 20,
                      }}
                    >
                      {item.expiryDate && (
                        <Text
                          style={{
                            fontSize: 18,
                          }}
                          type="secondary"
                        >
                          Expiry on{" "}
                          {moment(item.expiryDate, "YYYY-MM-DD").format(
                            "DD MMMM yyyy"
                          )}
                        </Text>
                      )}

                      <Typography.Text>
                        {item.status ? (
                          <Tag
                            style={{
                              width: 70,
                              textAlign: "center",
                            }}
                            color="green"
                          >
                            ACTIVE
                          </Tag>
                        ) : (
                          <Tag
                            style={{
                              width: 70,
                            }}
                            color="red"
                          >
                            EXPIRED
                          </Tag>
                        )}
                      </Typography.Text>
                    </Card>
                  </Fragment>
                );
              })}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default ShopProfile;
